export default "__VITE_ASSET__3Lol5Th5__"